<script setup lang="ts">
import { getVatClasses } from '@/api/utils'
import { computedAsync } from '@vueuse/core'
import { type VSelect } from 'vuetify/components'

defineOptions({
  name: 'VatSelect'
})

type Slots = VSelect['$slots']

const slots = defineSlots<Slots>()

const vatClasses = computedAsync(() => getVatClasses(), [], { flush: 'pre' })
</script>

<template>
  <VSelect
    :label="$t('form.label.vat_percentage')"
    :items="vatClasses"
    item-title="name"
    item-value="percentage"
  >
    <template v-for="(slot, index) in Object.keys(slots)" :key="index" #[slot]>
      <slot :name="slot" />
    </template>
  </VSelect>
</template>
